import type { ConfirmationModalProps } from '@library/components/modals/ConfirmationModal';
import { CopyToClipboardButton } from '@library/components/buttons';
import type { Status } from '@library/types/projection';
import type { TradingTeamBulkActions } from '@bo-hooks/trading/useTradingTeamBulkActions';
import { TradingTeamHeaderBulkActions } from '@bo-components/trading/games/TradingTeamHeaderBulkActions';
import { TradingTeamHeaderDurationIndicator } from '@bo-components/trading/games/TradingTeamHeaderDurationIndicator';

export interface TradingTeamHeaderProps {
  boardStatus: Status;
  durationDisplay?: string;
  firstBoardTime?: string;
  firstDisplayTime?: string;
  gameId: string;
  handleTogglePlayers: () => void;
  isBulkTeamInGameEnabled: boolean;
  primaryHeader: string;
  secondaryHeader: string;
  setConfirmationModalProps: (
    props: Omit<ConfirmationModalProps, 'onCancelModal'> | false
  ) => void;
  showPlayers: boolean;
  standardStartTimes: Array<string>;
  teamModalActions: {
    handleShowGameModes: () => void;
  };
  tradingTeamBulkActions: TradingTeamBulkActions;
  uniqueStartTimes: Array<string>;
  isDisplayTimeVisible?: boolean;
}

export const TradingTeamHeader = ({
  boardStatus,
  durationDisplay = '',
  firstBoardTime = undefined,
  firstDisplayTime = undefined,
  gameId,
  handleTogglePlayers,
  isBulkTeamInGameEnabled,
  primaryHeader,
  secondaryHeader,
  setConfirmationModalProps,
  showPlayers,
  teamModalActions,
  tradingTeamBulkActions,
  standardStartTimes,
  uniqueStartTimes,
  isDisplayTimeVisible = false
}: TradingTeamHeaderProps) => {
  return (
    <div className="bg-soFresh-120 border-soFresh-130 flex items-center border-b p-3 pl-4">
      <div className="font-heebo flex grow items-center gap-2 leading-5">
        <div className="flex-col">
          <div className="text-lg font-semibold">{primaryHeader}</div>
          <div className="text-soClean-160 max-w-[546px] text-sm">
            {secondaryHeader}
          </div>
        </div>
        <TradingTeamHeaderDurationIndicator durationDisplay={durationDisplay} />
        <div>
          <CopyToClipboardButton
            bannerMessage="Copied gameId to clipboard"
            btnClassName="size-10 hover:bg-soFresh-130 rounded-md text-soClean-180 hover:text-soClean-100"
            iconSize={4}
            textCopied={gameId}
          />
        </div>
      </div>
      <TradingTeamHeaderBulkActions
        boardStatus={boardStatus}
        firstBoardTime={firstBoardTime}
        firstDisplayTime={firstDisplayTime}
        handleTogglePlayers={handleTogglePlayers}
        isBulkTeamInGameEnabled={isBulkTeamInGameEnabled}
        setConfirmationModalProps={setConfirmationModalProps}
        showPlayers={showPlayers}
        tradingTeamBulkActions={tradingTeamBulkActions}
        tradingTeamModalActions={teamModalActions}
        standardStartTimes={standardStartTimes}
        uniqueStartTimes={uniqueStartTimes}
        isDisplayTimeVisible={isDisplayTimeVisible}
      />
    </div>
  );
};
